import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { formatDisplayDate, pnlDeduction, formatAmount, unapprovedWeekMap } from '../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';
import NotApprovedTag from '../../Pages/admin/shared/NotApprovedTag';

/* Week heading. Room for two lines on every column, so a "Not approved" tag that wraps in a
   narrow column does not push that column's table below its neighbours' (T1.35). */
const WEEK_HEAD = {
    padding: '6px 10px', minHeight: 56, display: 'flex', flexWrap: 'wrap',
    alignItems: 'center', justifyContent: 'center', rowGap: 2, textAlign: 'center',
};

class ByShop extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let { ReportDetails } = this.props;
        const unapproved = unapprovedWeekMap(this.props.UnapprovedWeeks);
        return (
            <div>
                {ReportDetails.map((totalShops, totalShopsIndex) => {
                    return (
                        <section style={{ background: "white" }} key={totalShopsIndex}>
                            <SectionHeader title={<>{totalShops.shopName}</>} />
                            <Row style={{ justifyContent: 'center' }} >
                                {totalShops.dataForReport.map((rd, index) => {
                                    // A week with no approved sale for this shop: label + marker only (T1.35).
                                    if (rd.noApprovedSale) return (
                                        <Col md={4} key={index} style={{ padding: "0px 5px" }} >
                                            <div style={WEEK_HEAD} ><strong style={{ color: "#d04e4a" }} >{rd.ToFromDate[0]} - {rd.ToFromDate[6]}</strong><NotApprovedTag info={unapproved.get(rd.weekCode)} /></div>
                                            <div style={{ textAlign: 'center', padding: '14px 10px', color: '#64748b', fontSize: 13, border: '1px dashed #e5e7eb', borderRadius: 8, background: '#fafafa' }} >No approved weekly sale this week</div>
                                        </Col>
                                    );
                                    return (
                                        <Col md={4} key={index} style={{ padding: "0px 5px" }} >
                                            <div style={WEEK_HEAD} ><strong style={{ color: "#d04e4a" }} >{rd.ToFromDate[0]} - {rd.ToFromDate[6]}</strong><NotApprovedTag info={unapproved.get(rd.weekCode)} /></div>
                                            <Paper>
                                                <TableContainer className="report-table-container" >
                                                    <Table className="report-table pc-shrink-table" size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Date & Day</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Cash</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Card</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Other</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {rd?.WeeklySale?.map((x, idx) => {
                                                                return (
                                                                    <TableRow
                                                                        className="table-rows"
                                                                        key={idx}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        <TableCell className="report-label-cell" >{formatDisplayDate(x.DateAndDay)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Cash)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Card)}</TableCell>
                                                                        <TableCell>{formatAmount(x.Others)}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                            )}
                                                            <TableRow
                                                                className="table-rows"
                                                                style={{ background: '#e7e7e7' }}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>Total</TableCell>
                                                                <TableCell><strong>{formatAmount(rd.WS_Cash)}</strong></TableCell>
                                                                <TableCell><strong>{formatAmount(rd.WS_Card)}</strong></TableCell>
                                                                <TableCell><strong>{formatAmount(rd.WS_Other)}</strong></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                            <div style={{ float: 'right' }} >
                                                <span style={{ color: '#d04e4a' }} >Total Sale: </span>{formatAmount(+rd.WS_Cash + +rd.WS_Card + +rd.WS_Other)}
                                            </div>
                                            <div style={{ padding: '10px', textAlign: 'center', marginTop: '10px' }} ><strong style={{ color: "#534ad0" }} >Expense</strong></div>
                                            <Paper>
                                                <TableContainer className="report-table-container" >
                                                    <Table className="report-table pc-shrink-table" size="small" aria-label="a dense table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Sr.No</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Description</TableCell>
                                                                <TableCell style={{ background: '#f1f1f1', color: '#111827' }} >Amount</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {rd?.WeeklySaleExpense?.map((service, idx) => (
                                                                <TableRow
                                                                    className="table-rows"
                                                                    key={idx}
                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                >
                                                                    <TableCell>{idx + 1}</TableCell>
                                                                    <TableCell>{service.description}</TableCell>
                                                                    <TableCell>{formatAmount(service.amount)}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow
                                                                className="table-rows"
                                                                style={{ background: '#e7e7e7' }}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell>Total</TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell><strong>{formatAmount(rd.WS_OtherExp)}</strong></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                            <div style={{ padding: '5px', float: 'right', textAlign: 'right', lineHeight: 1.6 }} >
                                                {/* The 25% is DISPLAY ONLY (helper.js PNL_RENDER_DEDUCTION).
                                                    WS_PRO_LOS itself is never touched, and the deduction is
                                                    derived from the stored figure. Literal in both
                                                    directions by decision: a loss shrinks by a quarter too.
                                                    One line, two figures, on the user's instruction
                                                    2026-10-14 (was three stacked rows). */}
                                                <div>
                                                    <span style={{ color: '#4842a7' }} >P/L: </span>{formatAmount(rd.WS_PRO_LOS)}
                                                    <span style={{ color: '#94a3b8', margin: '0 10px' }} >|</span>
                                                    <span style={{ color: '#4842a7' }} >0.25: </span>{formatAmount(pnlDeduction(rd.WS_PRO_LOS))}
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </section>
                    )
                })}
            </div>
        );
    }
}

export default ByShop;